import { Card, Divider, Input, Modal, Select } from 'antd';
import { encode } from 'html-entities';
import formatter from 'html-formatter';
import 'quill/dist/quill.snow.css';
import React, { useEffect, useState } from 'react';
import AceEditor from 'react-ace';
import { BiCodeAlt } from 'react-icons/bi';
import { MdPublish } from 'react-icons/md';
import { toast } from 'react-toastify';
import AdminServicesPYV2 from 'services/api/AdminServicesPYV2';
import { CardHeader } from '../../Components/Atoms/CardHeader';
import AdminServices from '../../services/api/AdminServices';
import Editor from './Editor';

function CreatePostNew() {
    const [allDescItems, setAllDescItems] = useState([]);
    const [instrumentType, setInstrumentType] = useState(4);
    const [name, setName] = useState('');
    const [color_code, setcolorcode] = useState(0);
    const [metric_data_type, setdatatype] = useState('float');
    const [metric_unit, setmetricunit] = useState('None');
    const [description, setDescription] = useState('');
    const [desc_id, setDesc_id] = useState('');
    const [previewHTML, setPreviewHTML] = useState(false);

    function onChange(data) {
        setDescription(data);
        document.getElementById("new").innerHTML = data;
        document.getElementById("new").scrollTop = document.getElementById("new").scrollHeight;
    }


    const updateInstrumentDescription = async (data) => {
        await AdminServicesPYV2.addMetricDesc({ params: JSON.stringify(data) }).then(res => {
            if (res.type) {
                toast.success('Published');
                getInstrumentDescriptions();
            }
            else {
                toast.error('Something went wrong!')
            }
        });
    }

    function handleSubmit(event) {
        let s = description;
        s = s.split('');
        let chars = ['\'']
        for (let i = 0; i < s.length; i++) {
            if (chars.includes(s[i])) {
                s[i] = encode(s[i]);
            }
        }
        s = s.join('');
        console.log(s);
        const data = {
            instrumentType,
            desc_id: desc_id,
            name: name,
            color_code: color_code,
            metric_data_type: metric_data_type,
            metric_unit: metric_unit === "None" ? null : metric_unit,
            description: s
        };
        updateInstrumentDescription(data);
    }

    const getInstrumentDescriptions = async () => {
        await AdminServices.getInstrumentDesc(instrumentType).then(res => {
            // console.log(res?.data,res?.data?.length + 1)
            setDesc_id(res?.data?.[res?.data?.length - 1]?.desc_id + 1);
        })
    }
    useEffect(() => {
        getInstrumentDescriptions();
    }, [instrumentType])
    return (
        <React.Fragment>
            <Card style={{ padding: 0 }} bodyStyle={{ padding: "1rem" }}>
                <CardHeader heading={'Create STOCK DESCRIPTION Doc'} />
                <div>Adding for id: {desc_id}</div>
                <Divider />
                <div className='margin20Bottom'>
                    <div className='mt-3'>
                        <label>Name:</label>
                        <br />
                        <Input placeholder='Title' value={name} name='title' onChange={(e) => {
                            setName(e.target.value);
                        }} style={{ padding: "5px 10px" }} className='textMD' />
                    </div>

                    <div className='mt-3'>
                        <label>Color Code:</label>
                        <br />
                        <Input placeholder='Title' value={color_code} name='title' onChange={(e) => {
                            setcolorcode(e.target.value);
                        }} style={{ padding: "5px 10px" }} className='textMD' />
                    </div>

                    <div className='mt-3'>
                        <label>Metric data type:</label>
                        <br />
                        <Select value={metric_data_type} placeholder='Select an item' style={{ width: '280px' }} onChange={(e) => {
                            setdatatype(e);
                        }}
                            className='mw-100' showSearch filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            } optionFilterProp="children" >
                            {['float', 'boolean', 'string', 'date'].map((item) => (
                                <option key={item} value={item} label={`${item}`}>
                                    {item}
                                </option>
                            ))}
                        </Select>
                        {/* <Input placeholder='Title' value={metric_data_type} name='title' onChange={(e) => {
                            setdatatype(e.target.value);
                        }} style={{ padding: "5px 10px" }} className='textMD' /> */}
                    </div>

                    <div className='mt-3'>
                        <label>Metric unit:</label>
                        <br />
                        <Select value={metric_unit} placeholder='Select an item' style={{ width: '280px' }} onChange={(e) => {
                            setmetricunit(e);
                        }}
                            className='mw-100'
                        >
                            {['rupee_cr', 'rupee', 'percentage', 'None'].map((item) => (
                                <option key={item} value={item} label={`${item}`}>
                                    {item}
                                </option>
                            ))}
                        </Select>
                        {/* <Input placeholder='Title' value={metric_unit} name='title' onChange={(e) => {
                            setmetricunit(e.target.value);
                        }} style={{ padding: "5px 10px" }} className='textMD' /> */}
                    </div>

                </div>
                <div>
                    <label> Description:</label>
                    <div className='d-flex mb-3 flex-column flex-md-row' style={{ gap: "20px" }}>
                        <div className="editor-kb" style={{ width: "55%", flexShrink: 0 }}>
                            <Editor onChange={onChange} description={description} desc_id={desc_id} />
                        </div>
                        <div style={{
                            border: "1px solid var(--grey1)", flexGrow: 1, overflow: "scroll", height: "370px",
                            display: "flex", flexDirection: "column", zIndex: 0,
                            borderRadius: "10px"
                        }}>
                            <div className='sticky-top p-2' style={{
                                borderBottom: "1px solid rgb(255,255,255,0.25)", fontSize: "17px", background: "var(--dark4)",
                                color: "var(--white)"
                            }}>
                                Preview Doc
                            </div>
                            <div id="new" className='ql-editor' style={{ background: "white", color: "black" }}>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="">
                    <button className="btnPrimary mr-4" onClick={handleSubmit} >
                        <MdPublish /> Publish
                    </button>
                    <button className='btnBlack' onClick={() => setPreviewHTML(true)}>
                        <BiCodeAlt className='mr-2' />See HTML
                    </button>
                </div>
                <Modal onOk={() => setPreviewHTML(false)} open={previewHTML} title='HTML Content' onCancel={() => setPreviewHTML(false)}
                    zIndex={1021} >
                    <AceEditor
                        placeholder="Write something"
                        mode="html"
                        fontSize={14}
                        onLoad={(editor) => {
                            editor.setReadOnly(true)
                        }}
                        width='100%'
                        showPrintMargin={true}
                        showGutter={true}
                        highlightActiveLine={true}
                        value={formatter.render(description)}
                        setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            wrap: true,
                        }} />
                </Modal>
            </Card>
        </React.Fragment>
    );
}

export default CreatePostNew;
